import { IBondGelemMarketReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_YIELD_LINKED_MARKET';

export type IReportYieldLinkedMarketItem = IBondGelemMarketReport & { __isSelected: boolean };
